var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "iugm-remove-file-btn",
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "iugm-remove-file-btn",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.7928 4.95036C15.1016 5.25917 15.1016 5.75985 14.7928 6.06866L5.3037 15.5577C4.99489 15.8666 4.49421 15.8666 4.1854 15.5577C3.87659 15.2489 3.87659 14.7483 4.1854 14.4394L13.6745 4.95036C13.9833 4.64155 14.484 4.64155 14.7928 4.95036Z",
    fill: "#2A2A64"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "iugm-remove-file-btn",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1854 4.95036C4.49421 4.64155 4.99489 4.64155 5.3037 4.95036L14.7928 14.4394C15.1016 14.7483 15.1016 15.2489 14.7928 15.5577C14.484 15.8666 13.9833 15.8666 13.6745 15.5577L4.1854 6.06866C3.87659 5.75985 3.87659 5.25917 4.1854 4.95036Z",
    fill: "#2A2A64"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalCloseIcon);
export default __webpack_public_path__ + "static/media/ModalCloseIcon.a0078fd3d79f591b94eae0a553f41710.svg";
export { ForwardRef as ReactComponent };